import React from "react";
import List from "@mui/material/List";
import { Link as RouterLink } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import HandshakeIcon from "@mui/icons-material/Handshake";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import ScheduleIcon from "@mui/icons-material/Schedule";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import BarChartIcon from "@mui/icons-material/BarChart";

import { routePaths } from "../routing/route-paths";

const AdminMenuList = (props: any) => {
  const { pathname } = props;

  return (
    <List>
      <ListItemButton
        component={RouterLink}
        to={routePaths.admin.taskBoard}
        selected={pathname.startsWith("/admin/task-board")}
      >
        <ListItemIcon>
          <ViewKanbanIcon />
        </ListItemIcon>
        <ListItemText primary="Task Board" />
      </ListItemButton>

      <ListItemButton
        component={RouterLink}
        to={routePaths.admin.engagements}
        selected={pathname.startsWith("/admin/engagements")}
      >
        <ListItemIcon>
          <HandshakeIcon />
        </ListItemIcon>
        <ListItemText primary="Engagements" />
      </ListItemButton>

      <ListItemButton
        component={RouterLink}
        to={routePaths.admin.invoices}
        selected={pathname.startsWith("/admin/invoices")}
      >
        <ListItemIcon>
          <RequestQuoteIcon />
        </ListItemIcon>
        <ListItemText primary="Invoices" />
      </ListItemButton>

      <ListItemButton
        component={RouterLink}
        to={routePaths.admin.timesheets}
        selected={pathname.startsWith("/admin/timesheets")}
      >
        <ListItemIcon>
          <ScheduleIcon />
        </ListItemIcon>
        <ListItemText primary="Timesheets" />
      </ListItemButton>

      <ListItemButton
        component={RouterLink}
        to={routePaths.admin.users}
        selected={pathname.startsWith("/admin/users")}
      >
        <ListItemIcon>
          <ManageAccountsIcon />
        </ListItemIcon>
        <ListItemText primary="Users" />
      </ListItemButton>

      <ListItemButton
        component={RouterLink}
        to={routePaths.admin.register}
        selected={pathname.startsWith("/admin/register")}
      >
        <ListItemIcon>
          <PersonAddAlt1Icon />
        </ListItemIcon>
        <ListItemText primary="Create New User" />
      </ListItemButton>

      <ListItemButton
        component={RouterLink}
        to={routePaths.dashboard.root}
        selected={pathname.startsWith("/dashboard")}
      >
        <ListItemIcon>
          <BarChartIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItemButton>
    </List>
  );
};

export default AdminMenuList;
